export const AvailabilityType = {
  isFulfillableIRGSku: ({ buyable, discontinued, status }) => {
    return !!(buyable && status && !discontinued);
  }
};
